"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildConfig = void 0;
var buildConfig = function (origin, email) { return ({
    topLevelDomain: "be",
    logoUrl: "https://vtm.be/favicon-32x32.png",
    bannerConfig: "BE-TV/Radio",
    // logoutUrl: `https://account.vtm.be/login?callback_url=${origin}`,
    logoutUrl: "https://account.vtm.be/logout?callback_url=".concat(origin, "/logout"),
    // authorizeUrl: () => `${origin}/login?feedback=false`,
    authorizeUrl: function () { return "https://account.vtm.be/login?callback_url=".concat(origin, "/login-callback"); },
    loggedInEmail: email || "",
    automaticLoginEnabled: true,
    intraSsoEnabled: true,
    multipleSessionsPopupEnabled: true,
}); };
exports.buildConfig = buildConfig;
